(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = Number(cents || 0) / 100;
    var formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    var template = format || '${{amount}}';
    var amount = formatted;

    if (template.indexOf('{{amount_no_decimals}}') !== -1) {
      amount = Math.round(value).toLocaleString();
      return template.replace('{{amount_no_decimals}}', amount);
    }

    return template.replace('{{amount}}', amount).replace('{{amount_with_comma_separator}}', amount);
  }

  function initializeProduct(root) {
    var variantsNode = root.querySelector('[data-product-variants]');
    var configNode = root.querySelector('[data-product-config]');
    var form = root.querySelector('[data-product-form]');
    var price = root.querySelector('[data-product-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var variantInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var stickyButton = root.querySelector('[data-sticky-submit]');
    var status = root.querySelector('[data-form-status]');
    var selectionMessage = root.querySelector('[data-selection-message]');
    var variants;
    var config;
    var selectedOptions = [];
    var selectedVariant = null;

    if (!variantsNode || !configNode || !form) return;

    try {
      variants = JSON.parse(variantsNode.textContent);
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      return;
    }

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-media-slide]'));
    var thumbnails = Array.prototype.slice.call(root.querySelectorAll('[data-media-thumbnail]'));
    var mediaTrack = root.querySelector('[data-media-track]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === options[index];
        });
      }) || null;
    }

    function isValueAvailable(optionIndex, value) {
      return variants.some(function (variant) {
        if (!variant.available || variant.options[optionIndex] !== value) return false;
        return variant.options.every(function (option, index) {
          return index === optionIndex || !selectedOptions[index] || option === selectedOptions[index];
        });
      });
    }

    function setMedia(mediaId) {
      if (!mediaId) return;
      slides.forEach(function (slide) {
        var active = String(slide.dataset.mediaId) === String(mediaId);
        slide.classList.toggle('is-active', active);
      });
      thumbnails.forEach(function (thumbnail) {
        var active = String(thumbnail.dataset.mediaId) === String(mediaId);
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-current', active ? 'true' : 'false');
      });

      var activeSlide = slides.find(function (slide) {
        return String(slide.dataset.mediaId) === String(mediaId);
      });
      if (activeSlide && mediaTrack && window.innerWidth < 900) {
        activeSlide.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
    }

    function updateOptionButtons() {
      optionGroups.forEach(function (group) {
        var index = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-option-value]').forEach(function (button) {
          var value = button.dataset.optionValue;
          var isSelected = selectedOptions[index] === value;
          button.disabled = !isValueAvailable(index, value);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      });
    }

    function updateVariant(nextVariant) {
      selectedVariant = nextVariant;
      updateOptionButtons();

      if (!selectedVariant) {
        variantInput.value = '';
        addButton.disabled = true;
        if (stickyButton) stickyButton.disabled = true;
        selectionMessage.textContent = 'This combination is unavailable. Please choose another option.';
        return;
      }

      variantInput.value = selectedVariant.id;
      addButton.disabled = !selectedVariant.available;
      if (stickyButton) stickyButton.disabled = !selectedVariant.available;
      selectionMessage.textContent = selectedVariant.available ? '' : 'This option is sold out.';
      var formattedPrice = selectedVariant.price === 0 ? 'Price upon request' : formatMoney(selectedVariant.price, config.moneyFormat);
      price.textContent = formattedPrice;
      if (stickyPrice) stickyPrice.textContent = formattedPrice;
      setMedia(selectedVariant.featured_media_id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', selectedVariant.id);
      window.history.replaceState({}, '', url.toString());
    }

    var initialVariant = variants.find(function (variant) {
      return String(variant.id) === String(config.initialVariantId);
    }) || variants.find(function (variant) { return variant.available; }) || variants[0];

    if (initialVariant) {
      selectedOptions = initialVariant.options.slice();
      updateVariant(initialVariant);
    }

    optionGroups.forEach(function (group) {
      var index = Number(group.dataset.optionIndex);
      group.querySelectorAll('[data-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectedOptions[index] = button.dataset.optionValue;
          updateVariant(findVariant(selectedOptions));
        });
      });
    });

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        setMedia(thumbnail.dataset.mediaId);
      });
    });

    function submitProductForm() {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', submitProductForm);
    }

    form.addEventListener('submit', function (event) {
      if (!selectedVariant || !selectedVariant.available || !window.fetch) return;
      event.preventDefault();
      var quantityInput = form.querySelector('[name="quantity"]');
      var quantity = Math.max(1, Number(quantityInput.value) || 1);
      var buttons = [addButton, stickyButton].filter(Boolean);
      buttons.forEach(function (button) {
        button.disabled = true;
        button.dataset.originalText = button.textContent;
        button.textContent = 'Adding…';
      });
      status.textContent = '';

      fetch(config.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedVariant.id, quantity: quantity }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(function () {
          status.textContent = 'Added to cart.';
          buttons.forEach(function (button) { button.textContent = 'Added'; });
          window.setTimeout(function () {
            buttons.forEach(function (button) {
              button.textContent = button.dataset.originalText || 'Add to Cart';
              button.disabled = false;
            });
          }, 1600);
        })
        .catch(function () {
          status.textContent = 'We could not add this item. Please try again.';
          buttons.forEach(function (button) {
            button.textContent = button.dataset.originalText || 'Add to Cart';
            button.disabled = false;
          });
        });
    });

    var sticky = root.querySelector('[data-sticky-cta]');
    var marker = root.querySelector('[data-product-form]');
    if (sticky && marker) {
      var setStickyVisibility = function (isVisible) {
        sticky.classList.toggle('is-visible', isVisible);
        sticky.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        document.body.classList.toggle('has-main-product-sticky', isVisible);
      };

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var formInView = entry.isIntersecting || entry.boundingClientRect.top >= 0;
          setStickyVisibility(!formInView);
        }, { threshold: 0 });
        observer.observe(marker);
      } else {
        var updateStickyFallback = function () {
          setStickyVisibility(marker.getBoundingClientRect().bottom <= 0);
        };
        window.addEventListener('scroll', updateStickyFallback, { passive: true });
        updateStickyFallback();
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-main-product]').forEach(initializeProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
